import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/operator/routing/global")({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: "/app/operator/routing",
      search: { view: "global" },
      hash: location.hash,
      replace: true,
    });
  },
});
